// Centralized API base URL configuration for the frontend
// Uses CRA env var REACT_APP_API_BASE_URL if provided; otherwise defaults by NODE_ENV.
// Production default points to the live API domain; development points to local docker compose.

export const API_BASE_URL: string =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://api.sh.co.ke/api/v1'
    : 'http://localhost:8004/api/v1');
